<template>
    <PreOrderDetail
        v-if="loaded && preOrder"
        :pre-order-units="preOrder.units"
        :pre-order="preOrder"
        @orderChanged="orderChanged"
        @addUnit="addUnit"
        @rowClicked="rowClicked"
    />
    <Page404 v-else-if="loaded" message="That Pre-Order was not found" />
</template>
<script>
import { mapState, mapActions } from "vuex";
import Page404 from "src/components/NotFoundPage.vue";
import store from "./_store";
import { mutations } from "src/global-store.js";
import PreOrderDetail from "./_components/PreOrderDetail.vue";

export default {
    name: "PreOrderDetailModule",
    components: {
        PreOrderDetail,
        Page404,
    },
    data() {
        return {
            loaded: false,
        };
    },
    computed: {
        ...mapState("$_preOrder", {
            preOrder: (state) => state.selectedPreOrder,
        }),
        customerName() {
            return this.preOrder.customer?.name;
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_preOrder", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_preOrder");
    },
    async created() {
        await this.fetchPreOrder(this.$route.params.id);
        const jobID = this.preOrder.CustomerJobID + " - ";
        mutations.setNavbarTitle(
            `Pre-Order #${this.preOrder.id}`,
            (this.preOrder.CustomerJobID ? jobID : "") +
                this.preOrder.customer?.name,
        );
        this.loaded = true;
    },

    methods: {
        ...mapActions("$_preOrder", ["fetchPreOrder", "moveUnit"]),
        orderChanged({ targetObject, list }) {
            const { preOrderId, unitId } = targetObject;
            const to = list.findIndex((unit) => unit.unitId === unitId);
            const from = unitId - 1;
            // Prevent unecessary API calls
            if (to === from) return;
            this.moveUnit({ preOrderId, from, to });
        },
        addUnit() {
            this.$router.push({
                name: "New Pre-Order Unit",
                params: { id: this.preOrder.id, preOrder: this.preOrder },
            });
        },
        rowClicked(row) {
            this.$router.push(
                `/preorder/${this.$route.params.id}/${row.unitId}`,
            );
        },
    },
};
</script>
